<template>
  <el-dialog
    :visible.sync="showDialog"
    :width="modalWidth"
    top="15vh"
    :modal-append-to-body="false"
    :before-close="handleClose"
    custom-class="custom-scrollable"
  >
    <div class="font-normal mb-4 mx-4">
      <div class="flex justify-center items-center flex-col">
        <div class="mt-3">
          <plain-batch-icon />
        </div>
        <p class="text-2xl mt-5 text-root-2 font-bold">Cancel Batch ?</p>
        <p
          style="word-break: normal"
          class="text-center mt-4 text-root-4 font-normal"
        >
          By pressing continue, all transactions with Batch Date
          <span class="font-bold">{{ routeDetails.id }}</span> will be
          cancelled.
        </p>
        <div class="mt-4 w-full">
          <o-button @click="next" class="w-full">Continue</o-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import breakpoints from '@/utils/breakpoints.js'
export default {
  name: 'CancelBatchDialog',
  data () {
    return {
      breakpoints
    }
  },
  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  components: {
    PlainBatchIcon: () => import('@/assets/icons/PlainBatchIcon.vue')
  },
  methods: {
    handleClose () {
      this.$emit('closeDialog')
    },
    next () {
      this.$emit('closeDialog')
      this.$emit('showDisapproveDialog')
    }
  },
  computed: {
    modalWidth () {
      return breakpoints.lgAndUp ? '37%' : breakpoints.mdAndUp ? '70%' : '90%'
    },
    routeDetails () {
      return {
        id: this.$route.params.id,
        status: this.$route.query.status,
        currency: this.$route.query.currency
      }
    }
  }
}
</script>

<style scoped></style>
